/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import * as config from "../assets/json-config/dev.json";

@Injectable()
export class AppConfig {
    // eslint-disable-next-line no-new-object
    private _configurations: any = new Object();

    private _my_config: {
        icon_position: string;
        icon_room_available: string;
        icon_room_unavailable: string;
        icon_room_chosen: string;
        MAX_CHARACTER_DESCRIPTION_TAG: number;
        DEFAULT_HEIGHT_HTML_TAG: number;
        DEFAULT_OPACITY_TAG: number;
        DEFAULT_WIDTH_HTML_TAG: number;
        MAX_IMAGE_HEIGHT_HTML_TAG: number;
    } = config;

    public get my_config(): {
        icon_position: string;
        icon_room_available: string;
        icon_room_unavailable: string;
        icon_room_chosen: string;
        MAX_CHARACTER_DESCRIPTION_TAG: number;
        DEFAULT_HEIGHT_HTML_TAG: number;
        DEFAULT_OPACITY_TAG: number;
        DEFAULT_WIDTH_HTML_TAG: number;
        MAX_IMAGE_HEIGHT_HTML_TAG: number;
    } {
        return this._my_config;
    }

    public set my_config(value: {
        icon_position: string;
        icon_room_available: string;
        icon_room_unavailable: string;
        icon_room_chosen: string;
        MAX_CHARACTER_DESCRIPTION_TAG: number;
        DEFAULT_HEIGHT_HTML_TAG: number;
        DEFAULT_OPACITY_TAG: number;
        DEFAULT_WIDTH_HTML_TAG: number;
        MAX_IMAGE_HEIGHT_HTML_TAG: number;
    }) {
        this._my_config = value;
    }

    private _configPath = "./assets/json-config/";

    constructor(private http: HttpClient) { }

    // Get an Environment Entry by Key
    // public getEnvByKey(key: any): any {
    //     return this._configurations.env[key];
    // }

    // Get a Configuration Entryby Key
    public getEntryByKey(key: any): any {
        return this._configurations.config[key];
    }

    // Should be self-explanatory
    public load() {
        return new Promise((resolve, reject) => {
            // Given env.json
            this.loadFile(`${this._configPath}env.json`).then(
                (environmentData: any) => {
                    this._configurations.env = environmentData;
                    // Load production or development configuration file based on before
                    this.loadFile(
                        `${this._configPath + environmentData.env}.json`,
                    ).then((config: any) => {
                        this._configurations.config = config;
                        return resolve(true);
                        // // Load resources files based on browser language
                        // this.loadFile(
                        //     `${this._resources_path +
                        //     translate.getBrowserLang()
                        //     }.json`,
                        // ).then((resource: any) => {
                        //     this._configurations.resource = resource;
                        //     return resolve(true);
                        // });
                    });
                },
            );
        });
    }

    private loadFile(path: string) {
        return new Promise((resolve, reject) => {
            this.http
                .get(path, { responseType: "text" })
                .pipe(
                    map((r) => JSON.parse(r)),
                    catchError((error) => {
                        return throwError(error.message);
                    }),
                )
                .subscribe((responseData) => {
                    return resolve(responseData);
                });
        });
    }
}
